const Inputt = (props) => {
  const {
    label,
    type,
    min,
    value,
    accept,
    readOnly,
    className,
    placeholder,
    name,
    invalidMsg,
    render,
    disabled,
  } = props;

  return (
    <div className={className.container ? className.container : ""}>
      {label && (
        <>
          <label
            htmlFor={"input-" + name}
            id={"label-" + name}
            className={className.label ? className.label : ""}
          >
            {label}
          </label>
          {render && render()}
        </>
      )}
      <input
        /* {...register} */
        onChange={props.onChange}
        id={"input-" + name}
        type={type}
        disabled={disabled}
        className={className.input ? className.input : ""}
        readOnly={readOnly}
        min={min}
        value={value ? value : ""}
        accept={accept}
        placeholder={placeholder}
      />

      {invalidMsg && <span className="ps-2 invalid">{invalidMsg}</span>}
    </div>
  );
};

export default Inputt;
